<template>
  <div>
    <div style="min-width: 1366px">
      <el-container style="height: calc(100vh - 80px);">
        <el-container>
          <div class="navWrap"
          style="background: #FFFFFF;
           box-shadow: 0px 0px 20px 0px rgb(130 127 127 / 21%);
           border-radius: 10px;margin: 20px 0px 20px 20px;">
            <el-button
              style="
                width: 132px;
                height: 36px;
                border-radius: 5px;
                margin-bottom: 28px;
              "
              :class="lang === 'zh'?'':'en-button'"
              type="primary"
              icon="el-icon-search"
              @click="pathIndex()"
              >{{$t('i18n_Check_Pricing_and_order')}}</el-button
            >
            <el-aside width="240px">
              <el-menu
                :router="routerType"
                :default-active="path"
                class="el-menu-vertical-demo"
                unique-opened
                @open="handleOpen"
                @close="handleClose"
                @select="pathTo"
              >
                <el-submenu
                  :index="index + 1 + ''"
                  v-for="(item, index) in navList"
                  :key="index"
                >
                  <template slot="title">
                    <i :class="item.icon"></i>
                    <span style="font-size: 16px;
                     font-family: PingFang SC;
                    font-weight: bold; color: #333333;"
                    >{{ lang === 'zh' ? item.name : item.namee }}</span>
                  </template>
                  <el-menu-item-group
                    v-for="(_item, _index) in item.nextNodes"
                    :key="_index"
                  >
                    <el-menu-item :index="_item.code">{{
                      lang === 'zh' ? _item.name : _item.namee
                    }}</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
              </el-menu>
            </el-aside>
          </div>
          <el-container>
            <el-main>
              <div class="maindiv">
                <el-scrollbar>
                  <router-view />
                </el-scrollbar>
              </div>
            </el-main>
          </el-container>
        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      noTpath: null,
      path: "",
      routerType: true,
      navList: [
        {
          name: "订单管理",
          icon: "el-icon-tickets",
          index: "1",
          children: [
            {
              indexName: "BulkOrderbysea",
              lable: "海运散货",
              path:
                "/index/PersonalCenter/Personalindex/PersonalCenter/BulkOrder/BulkOrderbysea",
            },
            {
              indexName: "Mybill",
              lable: "海运整柜",
              path: "/index/PersonalCenter/Personalindex/PersonalCenter/buikAllbox/buikAllbox",
            },
            {
              indexName: "",
              lable: "国际空运",
              path: "/index/PersonalCenter/Personalindex/PersonalCenter/transport/transport",
            },
            {
              indexName: "",
              lable: "FBA头程",
              path: "/index/PersonalCenter/Personalindex/PersonalCenter/FBAheader/FBAheader",
            },
            {
              indexName: "",
              lable: "跨境小包",
              path: "/index/PersonalCenter/Personalindex/PersonalCenter/Smallbag/Smallbag",
            },
          ],
        },
        {
          name: "财务管理",
          icon: "el-icon-money",
          index: "2",
          children: [
            {
              indexName: "Mybill",
              lable: "我的费用",
              path:
                "/index/PersonalCenter/Personalindex/PersonalCenter/billType/Mybill",
            },
            {
              indexName: "PayRecord",
              lable: "我的账单",
              path:
                "/index/PersonalCenter/Personalindex/PersonalCenter/billType/PayRecord",
            },
          ],
        },
        {
          name: "个人资料",
          icon: "el-icon-user",
          index: "3",
          children: [
            {
              indexName: "SendPage",
              lable: "发货人",
              path:
                "/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/SendPage",
            },
            {
              indexName: "ReceivePage",
              lable: "收货人",
              path:
                "/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/ReceivePage",
            },
            {
              indexName: "PickPage",
              lable: "提货人",
              path:
                "/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/PickPage",
            },
            {
              indexName: "TrackSetting",
              lable: "轨迹推送",
              path:
                "/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/TrackSetting",
            },{
              indexName: "Classify",
              lable: "轨迹推送",
              path:
                "/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/Classify",
            },
          ],
        },
        {
          name: "账户管理",
          icon: "el-icon-setting",
          index: "4",
          children: [
            {
              indexName: "UserManage",
              lable: "用户管理",
              path:
                "/index/PersonalCenter/Personalindex/PersonalCenter/accountManage/UserManage",
            },
            {
              indexName: "SubaccountManage",
              lable: "子账号管理",
              path:
                "/index/PersonalCenter/Personalindex/PersonalCenter/accountManage/SubaccountManage",
            },
            {
              indexName: "ManagementRole",
              lable: "角色管理",
              path:
                "/index/PersonalCenter/Personalindex/PersonalCenter/accountManage/ManagementRole",
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {
    $route: "onRouteChanged",
  },
  methods: {
    hasChildren(children){
    },
    onRouteChanged() {
      this.path = this.$route.path;
    },
    pathIndex() {
      this.$router.push({
        path: "/index/placeOrder/placeIndex",
      });
    },
    handleOpen(key, keyPath) {
      // console.log('handleOpen');
      // console.log(key);
    },
    handleClose(key, keyPath) {},
    pathTo(index, indexPath) {
      // console.log('pathTo');
      // console.log(index);
      this.noTpath = index;
      if (!index)
        return this.$message({
          message: "当前业务暂未开放，敬请期待。。。",
          type: "warning",
        });
    },
  },
  created() {
    this.onRouteChanged();
    let user = sessionStorage.getItem("Authorization");
     user = JSON.parse(user);
    // console.log( user.authorities);
    this.navList = user.authorities
    let authList = []
    authList.push('/')
    authList.push('/index/placeOrder/placeIndex')
    authList.push('/index/PersonalCenter/Personalindex/PersonalCenter/userCountshow')
    if(this.navList.length && this.navList.length > 0){
      this.navList.forEach(v =>{
          v.nextNodes.forEach(v2 =>{
            authList.push(v2.code)
          })
      })
    }
    if(authList.length > 0){
      sessionStorage.setItem('authList',JSON.stringify(authList))
    }
     let temp =  sessionStorage.getItem('authList')
    //  console.log(JSON.parse(temp));
  },
  mounted() {},
};
</script>
<style scoped>
.navWrap>>>.el-menu-item-group__title{
  padding: 0!important;
}
.navWrap >>> .el-menu {
  border-right: none;
}
.navWrap >>> .el-submenu__title {
  padding: 0 50px;
}
.navWrap {
  padding-top: 28px;
  box-sizing: border-box;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
    0 2px 4px 0 rgba(232, 237, 250, 0.5);
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-direction: column;
}
.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  color: #333;
  /* text-align: center; */
}

body > .el-container {
  margin-bottom: 40px;
  height: 100%;
}

/* .el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
} */

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
.el-aside::-webkit-scrollbar {
  display: none;
}
.el-aside {
  /*隐藏滚动条，当IE下溢出，仍然可以滚动*/
  -ms-overflow-style: none;
  /*火狐下隐藏滚动条*/
  scrollbar-width: none;
}
.maindiv {
  background: #ffffff;
  box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
  border-radius: 10px;
  height: 100%;
  width: calc(100vm - 220px);
  overflow: auto;
}
.el-button {
  width: fit-content;
}
.en-button {
  width: 162px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/Personalindex.vue